module.exports = __webpack_public_path__ + "images/store_case_study/kld-pic2_db56098e3a0a4f42ab670d0af75dfa14.png";